module.exports = __webpack_public_path__ + "static/media/delete.a000b113.svg";